import React from 'react';
import { Typography } from '@mui/material';
import { browserTime } from 'utils/time';

export default function RestoredScheduleNotice({ restored, startAt, endAt }) {
  const now = Date.now();
  const start = browserTime(startAt);
  const end = browserTime(endAt);
  if (!restored || !start.isValid() || !start.isBefore(now)
    || (end.isValid() && !end.isAfter(now))) return null;
  return (
    <Typography variant="body2" color="text.secondary" sx={{ my: 1 }}>
      The original start time has passed. This offer will start when you publish.
    </Typography>
  );
}
